import { useEffect, useState } from 'react';
import Participants from '../ui/Participants';
import { useParticipants } from '../discord/useParticipants';
import { affiche } from '../lib/images';

/**
 * Avant que le film commence.
 *
 * La salle ouvre un quart d'heure avant : le temps que les gens arrivent et
 * voient ce qu'ils vont regarder. Un compte à rebours plutôt qu'une heure
 * fixe — « dans 4 minutes » se comprend sans calcul, et sans se demander dans
 * quel fuseau l'heure est écrite.
 *
 * Rien à cliquer, et c'est voulu : la projection démarre toute seule.
 */

function compteARebours(secondes) {
  const total = Math.max(0, Math.round(secondes));
  const minutes = Math.floor(total / 60);
  const reste = total % 60;

  if (minutes >= 1) return `${minutes} min ${String(reste).padStart(2, '0')} s`;
  return `${reste} seconde${reste > 1 ? 's' : ''}`;
}

export default function SalleAttente({ projection, attenteRestante }) {
  const participants = useParticipants();
  const [restant, setRestant] = useState(() => attenteRestante());

  useEffect(() => {
    const battement = setInterval(() => setRestant(attenteRestante()), 1000);
    return () => clearInterval(battement);
  }, [attenteRestante]);

  const image = affiche(projection.movie_poster);
  const debut = new Date(projection.scheduled_at);

  return (
    <div className="centre">
      {image && <img className="attente-affiche" src={image} alt="" />}

      <h1 className="titre">{projection.movie_title}</h1>

      <p className="compte-a-rebours">{compteARebours(restant)}</p>
      <p className="discret">
        Départ à {debut.toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' })}
        {projection.created_by_name ? ` · séance de ${projection.created_by_name}` : ''}
      </p>

      <Participants participants={participants} />

      <p className="discret petit">
        Le film démarre tout seul, pour tout le monde en même temps.
        Tu n'as rien à faire.
      </p>
    </div>
  );
}
